// Default imports
import React from "react";
import WpImage from "./WpImage";

const ImagesGallery = ({ images, className, customClass, ...args }) =>
    images && images.length > 0 ? (
        <div
            className={`images-gallery transparent ${
                className ? className : ""
            } ${customClass ? customClass : ""}`}
            {...args}
        >
            {images.map((image, index) => (
                <WpImage
                    image={image}
                    className={`images-gallery__item greyscale ${
                        customClass ? `${customClass}__item` : ""
                    }`}
                    key={index}
                    objectFit="contain"
                />
            ))}
        </div>
    ) : (
        <></>
    );
export default ImagesGallery;
